<template>
  <div class="wr-debt-person-home">
    <nav-bar titleText="万融解债" @goBack="goBack"></nav-bar>
    <div v-if="!show && canEdit">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        
        <div class="debtor-box" v-if="debtorCount == 0" @click="toDebtorHome">
          <div class="title">以债务人身份申请解债</div>
          <div class="debtor-title">我是债务人</div>
          <div class="attention-text">
            <img src="../../assets/debtor/attention.png" alt="">
            <span @click.stop="grasp(2,$event)">点我了解什么是债务人</span>
          </div>
          <div class="status-box" @click="applyDebtor">
            <span>申请解债</span>
          </div>
        </div>

        <div class="debtor-box2" v-if="debtorCount > 0">
          <div class="debtor-title">我是债务人</div>
          <div class="debtor-info">共计{{ debtorCount }}个订单</div>
          <div class="status-box" @click="toDebtorHome">
            <span>进入</span>
          </div>
        </div>

        <div class="creditor-box" v-if="creditorOrderListCount == 0" @click="toCreditorHome">
          <div class="title">以债权人身份申请解债</div>
          <div class="creditor-title">我是债权人</div>
          <div class="attention-text">
            <img src="../../assets/debtor/attention.png" alt="">
            <span @click.stop="grasp(3,$event)">点我了解什么是债权人</span>
          </div>
          <div class="status-box" @click="applyCreditor">
            <span>申请解债</span>
          </div>
        </div>

        <div class="creditor-box2" v-if="creditorOrderListCount > 0">
          <div class="creditor-title">我是债权人</div>
          <div class="creditor-info">共计{{ creditorOrderListCount }}个订单</div>
          <div class="status-box" @click="toCreditorHome">
            <span>进入</span>
          </div>
        </div>

        <div class="contact-service" @click="chat">
          <span>遇到问题？</span>
          <span >联系客服，为您解答</span>
          <img src="../../assets/debtor/right-arrow.png">
        </div>
      </van-pull-refresh>


      <div class="application-broker" @click="applyAgent" v-if="[994, 992, 422, 99989].includes(status)">
        <img src="../../assets/debtor/addBroker.png">
        <div>申请成为经纪人</div>
      </div>
      <div class="agent-attention" @click.stop="grasp(4,$event)" v-if="[994, 992, 422, 99989].includes(status)"><img src="../../assets/debtor/attention.png" alt="">点我了解什么是解债经纪人</div>

      <div class="application-broker" v-if="status === 993 || status === -2">
        <img src="../../assets/debtor/sign.png">
        <!-- 跳转签署合同页面  2 合同撤回-->
        <div style="color: #F9591B" @click="signature">立即签署经纪人合同</div> 
      </div>
      <div class="application-broker" v-if="status === 990">
        <img src="../../assets/debtor/review.png">
        <div style="color: #999999">经纪人合同信息审核中</div>
      </div>

      <div class="application-broker-new" v-if="status === -1">
        <div style="color: #999999">合同驳回：经纪费原路退回,详询客服</div>
        <div style="color: #F9591B;font-size:15px;margin-top:5px">驳回理由：{{reject_reason}}</div>
        <div class="replay-sign-btn" @click="applyAgent">再次开通</div> 

      </div>

      <!-- <div class="application-broker-new" v-if="status === -2">
        <div style="color: #999999">合同撤回：经纪费退至会员余额,详询客服</div>
        <div class="replay-sign-btn" @click="applyAgent">再次开通</div> 
      </div> -->
      <div class="application-broker-new" v-if="status === -3">
        <div style="color: #999999">合同失效：经纪费原路退回,详询客服</div>
        <div class="replay-sign-btn" @click="applyAgent">再次开通</div> 
      </div>

      <div class="application-broker-new" v-if="status === -4">
        <div style="color: #999999">合同作废：详询客服</div>
        <div class="replay-sign-btn" @click="applyAgent">再次开通</div> 
      </div>

      <div class="application-broker-one" v-if="[0, 1, 2, 991].includes(status)">
        <div style="color: #999999; text-align: center;">- 您已成为经纪人 -</div>
        <img :src="!agentInfo.member_avator ? agentimg : agentInfo.member_avator" class="last-img">
        <div class="name">{{agentInfo.member_realname}}</div>
        <div class="level">级别 {{agentLevel}}</div>
        <div class="code">经纪人代码 {{agentInfo.agent_code}}</div>

        <div class="gohome" @click="goAgentHome" v-if="status === 0">
          <div class="top">
            <span>进入经纪人主页</span>
            <img src="../../assets/debtor/right-arrow.png" class="icon">
          </div>
          <div class="agent-order-count">共计{{ agentInfo.number }}个订单</div>
        </div>
        
        <div class="error-status-freeze" v-if="status === 1">
          <p class="status">被冻结</p>
          <p class="order-count">共计{{ agentInfo.number }}个订单</p>
          <div class="btn" @click="chat">联系客服</div>
        </div>

        <div class="error-status-expire" v-if="status === 2 || status === 991">
          <p class="status">经纪人合同到期</p>
          <p class="order-count">共计{{ agentInfo.number }}个订单</p>
          <div class="btn" @click="applyAgent">续签</div>
        </div>
      </div> 

    </div>
    <van-dialog
     v-model="showDialog"
     message="经纪人身份被冻结，请联系客服"
     title="提示"
     confirm-button-text="联系客服"
     confirm-button-color="#F9591B"
     cancel-button-text="取消"
     cancel-button-color="#999999"
     @confirm="chat"
     show-cancel-button
    ></van-dialog>

    <!-- <van-popup v-model="show">
    	<div class="box">
    		<img src="../../assets/common/BG@2x.png" alt="" />
    		<p class="title">温馨提示</p>
    		<p class="tips">该业务即将上线，敬请期待！</p>
    		<span @click="goBack()">好的</span>
    	</div>
    </van-popup> -->


    <van-popup v-model="show1">
    	<div class="grasp-debtor-box">
    		<div class="title">{{show1Title}}</div>
    		<p class="tips content" v-html="content1"></p>
        <p class="call-service content" @click="chat">点此联系解债业务客服></p>
    		<div @click="show1 = false" class="van-hairline--top btn">知道了</div>
    	</div>
    </van-popup>

  </div>
</template>

<script>
import navBar from "./components/navBar";
export default {
  name: "wrDebtPersonHome",
  data() {
    return {
      debtorOrderStatusDesc: "",
      debtorOrderStatusAction: "",
      debtorClick: {},
      debtorCount: 0,
      creditorOrderListCount:0,
      creditorOrderStatusAction:'',
      agentInfo:{},
      // 0 已经成为经纪人  994 申请成为经纪人  993 经纪人合同信息审核中
      status: -5,
      account_id:'',  // 账户id
      agent_contract_id:'',// 经纪人合同id
      // 1 冻结  2 合同到期
      freeze: -10,
      showDialog: false,
      isLoading: false,
      show: false,  //控制弹框和内容，true则显示
      canEdit: false, //防止模块闪一下消失 show为false且canEdit为true内容显示
      show1: false,
      content1: '',
      show1Title: '债务人',
      agentLevel: '',
      agentimg:require('@/assets/debtor/actver.png'),
      reject_reason:''
    }
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }else if(localStorage.getItem('_token')){
        this.$api.setToken(localStorage.getItem('_token'));
    }
     this.$api.post('/debt/member/debt/display')
      .then(data => {
        this.show = false;
        this.canEdit = true;
        this.onload()
      })
      .catch(err => {
        this.show = true;
      })
  },
  mounted() {
    // this.content1 = this.content1.split('\n')
  },
  components: {
    navBar,
  },
  computed: {
  },
  methods: {
    toDebtorHome(){
      this.$router.push("/debtor/debtorView")
    },
    toCreditorHome(){
      this.$router.push("/creditor/creditorView")
    },
    applyDebtor(e){
      e.stopPropagation()
      this.$router.push('/debtRelief/solutionDebtInfoDebtor')
    },
    applyCreditor(e){
      e.stopPropagation()
      this.$router.push('/debtRelief/solutionDebtInfoCreditor')
    },
    onRefresh(){
      this.onload()
    },
    onload(){
      Promise.all([this.isReleaseDebtorOrder(), this.isCreditorOrder(), this.getAgentStatus()])
      .then(res => {
        this.isLoading = false
      })
      .catch(err => {
        this.isLoading = false
      })
    },
    goBack() {
      // this.$router.go(-1)
       this.$router.push({
            path: '/debtRelief/businessDesc',
            query: {
              token: localStorage.getItem('_token') || this.$route.query.token
            }
          })
    },
    signature() {
      this.$router.push({
        path:'/agent/contractView',
        query: { 
          contract_id: this.agent_contract_id, 
          debt_from: 'home',
        }
      })
    },
    // 债务人是否发布解债订单及条数
    isReleaseDebtorOrder() {
      return new Promise((resolve, reject) => {
        this.$api.post("/debt/member/debtor-order/count").then((data) => {
          resolve()
          this.debtorCount = parseInt(data.list);
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    // 债权人是否有解债订单及条数
    isCreditorOrder() {
      return new Promise((resolve, reject) => {
        this.$api.post('/debt/member/creditor/creditor-order/order-count').then(data => {
          resolve()
          this.creditorOrderListCount = parseInt(data.count)
          // this.creditorOrderListCount = 0
        })
        .catch(err => {
          reject(err)
        })

      })

    },

    // 经纪人状态
    getAgentStatus() {
      return new Promise((resovle, reject) => {
        this.$api.post('/debt/member/status').then(data => {
          this.agentInfo = data
          this.account_id = data.account_id
          this.agent_contract_id = data.agent_contract_id
          this.status = 0
          this.freeze = data.freeze
          if(data.code){
            this.reject_reason = data.reject_reason
            this.status = data.code
          this.agent_contract_id = data.agent_contract_id
          if(data.code == 991){
            this.status = 2
          }
          // 992没有找到该会员
          if(data.code == 992){
            this.status = 992
          }
          // this.status = 2
          if(data.code == 993 && data.freeze == 0 ){
            this.status = 993
          }
          if(data.code == 993 && data.freeze == -2){
            this.status = -2
          }
          if(data.code == 993 && data.freeze == -3){
            this.status = -3
          }
          if(data.code == 993 && data.freeze == -4){
            this.status = -4
          }

          if(data.code == 994 ){
            this.status = 994
          }
          if(data.code == 990 && data.freeze == 0){
            this.status = 990
          }
          if(data.code == 990 && data.freeze == -1){
            this.status = -1
          }
        
          if(data.code == 990 && data.freeze == -2){
            this.status = -2
          }
          if(data.code == 990 && data.freeze == -3){
            this.status = -3
          }
          }
          if (data.freeze == 1) this.status = 1
          if (data.freeze == 2) this.status = 2  
          if (data.freeze == -4) this.status = -4  
          if (data.freeze == -1) this.status = -1 // 驳回状态
          if (data.code == 99989) this.status = 99989
          if(data.agent_identity == 0){
            this.agentLevel = '普通'
          }else if(data.agent_identity == 1) {
            this.agentLevel = '主管'
          }else if(data.agent_identity == 2) {
            this.agentLevel = '经理'
          } 
          resovle()
          // this.status = 1
        })
        // .catch(res => {
        //   this.status = res.code
        //   this.agent_contract_id = res.data.agent_contract_id
        //   if(res.code == 991){
        //     this.status = 2
        //   }
        //   // 992没有找到该会员
        //   if(res.code == 992){
        //     this.status = 992
        //   }
        //   // this.status = 2
        //   if(res.code == 993 && res.data.freeze == 0 ){
        //     this.status = 993
        //   }
        //   if(res.code == 993 && res.data.freeze == -2){
        //     this.status = -2
        //   }
        //   if(res.code == 993 && res.data.freeze == -3){
        //     this.status = -3
        //   }
        //   if(res.code == 993 && res.data.freeze == -4){
        //     this.status = -4
        //   }

        //   if(res.code == 994 ){
        //     this.status = 994
        //   }
        //   if(res.code == 990 && res.data.freeze == 0){
        //     this.status = 990
        //   }
        //   if(res.code == 990 && res.data.freeze == -1){
        //     this.status = -1
        //   }
        
        //   if(res.code == 990 && res.data.freeze == -2){
        //     this.status = -2
        //   }
        //   if(res.code == 990 && res.data.freeze == -3){
        //     this.status = -3
        //   }


        //   reject(res)
        // })
      })

    },
    // 申请成为经纪人
    applyAgent() { 
      this.$router.push({
        path: '/agent/introduceMyself',
        query: {
          // account_id: this.account_id,
        }
      });
    },
    // 进入经纪人主页
    goAgentHome(){
      this.$router.push({
        path: '/agent/agentView',
      })
    },
    //联系客服跳原生
    chat() {
      this.showDialog = false
      this.params('18', '18', 'customerService')
    },
    // 点击弹框说明
    grasp(id,e){
      e.stopPropagation()
      this.show1 = true
      this.content1 = ''
      const param = {
        id: id,
      }
      // console.log(id)
      // console.log(e)
      this.$api.post('debt/member/setting/get-content-setting', param)
      .then((data) => {
        this.content1 = data.details
        this.show1Title = data.title
      })
    },

  },
};
</script>


<style lang="less">
.wr-debt-person-home {
  padding-top: 88px;
  box-sizing: border-box;
  position: relative;
  .debtor-box,
  .creditor-box,
  .debtor-box2,
  .creditor-box2 {
    // width: fit-content;
    height: 109px;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(153, 153, 153, 0.12);
    border-radius: 4px;
    border: 1px solid #eeeeee;
    margin: 12px;
    padding: 14px 0 15px 21px;
    box-sizing: border-box;
    position: relative;
    .title {
      height: 19px;
      font-size: 12px;
      color: #999999;
      line-height: 19px;
    }
    .debtor-title,
    .creditor-title {
      // width: 100%;
      width: fit-content;
      height: 32px;
      line-height: 32px;
      font-size: 20px;
      font-weight: 600;
      color: #333333;
    }
    .attention-text {
      display: flex;
      align-items: center;
      img {
        width: 15px;
        height: 15px;
      }
      span {
        height: 23px;
        font-size: 14px;
        color: #333333;
        line-height: 23px;
      }
    }
    .debtor-info,
    .creditor-info {
      width: 100%;
      height: 23px;
      line-height: 23px;
      font-size: 14px;
      color: #999999;
    }
    .status-box {
      // width: 69px;
      min-width: 30px;
      height: 32px;
      line-height: 32px;
      background: #2a62fc;
      border-radius: 16px;
      text-align: center;
      position: absolute;
      top: 50%;
      right: 27px;
      transform: translate(0, -50%);
      padding: 0 15px;
      span {
        line-height: 24px;
        font-size: 15px;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
  .debtor-box2 {
    padding: 26px 0 26px 21px;
    .status-box {
      background:#2a62fc;
    }
  }

  .creditor-box {
    margin: 0 12px;
  }
  .creditor-box2 {
    padding: 26px 0 26px 21px;
    .status-box {
      background: #F9591B;
    }
  }


  .contact-service {
    margin-top: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    :nth-of-type(1) {
      height: 22px;
      font-size: 14px;
      color: #999999;
      line-height: 22px;
    }
    :nth-of-type(2) {
      height: 22px;
      font-size: 14px;
      color: #666666;
      line-height: 22px;
      margin-right: 6px;
    }
    img {
      width: 10px;
      height: 13px!important;
    }
  }
  .application-broker-new{
    width: 100%;
    position: fixed;
    bottom: 71px;
    left: 50%;
    transform: translate(-50%,0);
    text-align: center;
    .replay-sign-btn{
      color: #999999;
      padding: 3px 5px;
      border: 1px solid #999999;
      display: inline-block;
      width: auto;
      margin-top: 15px;
    }
  }
  .application-broker,
  .agent-attention {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 71px;
    left: 50%;
    transform: translate(-50%,0);
    
    img {
      width: 24px;
      height: 24px;
      margin-right: 2px;
      // vertical-align:bottom;
    }
    div {
      height: 26px;
      font-size: 16px;
      color: #F9591B;
      line-height: 26px;
    }
   
   
  }
  .agent-attention {
    font-size: 13px;
    color: #333333;
    line-height: 21px;
    bottom: 38px;

    img {
      height: 15px;
      width: 15px;
    }
  }
  .application-broker-one {
    position: fixed;
    transform: translate(-50%,0);
    bottom: 32px; 
    left: 50%;
    @media (max-height: 640px) {
      position: inherit;
      transform: none;
    }
    :nth-of-type(1) {
      margin: 0 auto;
    }
    :nth-of-type(2) {
      text-align: center;
    }
    .last-img {
      width: 44px;
      height: 44px;
      display: block;
      margin: 15px auto 5px;
      padding-bottom: 6px;
      border-radius: 50%;
    }
    .name,
    .level {
      font-size: 15px;
      color: #333333;
      line-height: 24px;
      text-align: center;
      margin-bottom: 4px;
    }
    .level {
      margin-bottom: 0;
    }
    .code {
      line-height: 24px;
      font-size: 15px;
      color: #333333;
      text-align: center;
    }
    .gohome {
      // display: flex;
      // align-items: center;
      // margin-top: 6px;
      .top {
        width:fit-content;
        display: flex;
        align-items: center;
        // margin-top: 6px;
        span {
          height: 24px;
          line-height: 24px;
          font-size: 15px;
          color: #333333;
          font-weight: 700;
        }
        .icon {
          width: 15px;
          height: 15px;
          margin-left: 3px;
        }
      }
      .agent-order-count {
        margin-top: 9px;
        height: 24px;
        font-size: 15px;
        color: #999999;
        line-height: 24px;
        @media (max-height: 613px) {
          margin-bottom: 20px;
        }
      }
    }
    .error-status-freeze,
    .error-status-expire {
      .status {
        font-size: 15px;
        color: #999999;
        line-height: 24px;
        // margin-bottom: 6px;
        text-align: center;
      }
      .order-count {
        margin: 9px 0;
        font-size: 15px;
        color: #999999;
        line-height: 24px;
        text-align: center;
      }
      .btn {
        width: fit-content;
        background: #FC740C;
        color: #FFFFFF;
        border-radius: 16px;
        padding: 4px 13px;
        height: 24px;
        font-size: 15px;
        font-weight: 500;
        line-height: 24px;
      }
    }

  }
  .grasp-agent {
    height: 21px;
    font-size: 13px;
    color: #333333;
    line-height: 21px;
    position: fixed;
    bottom: 38px;
    left: 50%;
    transform: translate(-50%,0);
  }
  .van-pull-refresh {
    padding-bottom: 100px;
    @media (max-height: 640px) {
        padding-bottom: 20px;
    }
  }
  
    .van-popup--center{
      width: calc(100% - 67px);
      max-height: calc(100% - 200px);
      overflow-y: scroll;
		  border-radius: 10px;
		.box{
			img {
				display: block;
				width: 100%;
			}
			.title {
				color: #333;
				font-size: 15px;
				font-weight: 600;
				line-height: 47px;
				margin-top: 8px;
				text-align: center;
			}
			.tips {
				color: #333;
				font-size: 13px;
				line-height: 18px;
				text-align: center;
				margin-bottom: 30px;
			}
			span {
				width: 100%;
				border-top: solid 1px #F2F2F2;
				line-height: 43px;
				color: #E6212F;
				font-size: 14px;
				text-align: center;
				display: inline-block;
			}
    }
    .grasp-debtor-box {
      padding: 20px 21px 0;
      .title {
        width: 100%;
        text-align: center;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        line-height: 25px;
        margin-bottom: 8px;
      }
      .content {
        font-size: 15px;
        color: #333333;
        line-height: 24px;
      }
      .tips {

      }
      .call-service {
        color: #2A62FC;
        margin-bottom: 18px;
      }
      .btn {
        width: 100%;
        height: 28px;
        font-size: 17px;
        font-weight: 700;
        color: #F9591B;
        line-height: 28px;
        padding: 11px 0;
        width: 100%;
        text-align: center;
      }
    }
    
  }
  
}
</style>
